var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 2.83317C8.46089 2.83317 8.83398 2.46007 8.83398 1.99984C8.83398 1.5396 8.46089 1.1665 8.00065 1.1665C7.54041 1.1665 7.16732 1.5396 7.16732 1.99984C7.16732 2.46007 7.54041 2.83317 8.00065 2.83317Z",
    fill: "#C3C4C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 2.83317C14.2942 2.83317 14.6673 2.46007 14.6673 1.99984C14.6673 1.5396 14.2942 1.1665 13.834 1.1665C13.3737 1.1665 13.0007 1.5396 13.0007 1.99984C13.0007 2.46007 13.3737 2.83317 13.834 2.83317Z",
    fill: "#C3C4C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16732 2.83317C2.62755 2.83317 3.00065 2.46007 3.00065 1.99984C3.00065 1.5396 2.62755 1.1665 2.16732 1.1665C1.70708 1.1665 1.33398 1.5396 1.33398 1.99984C1.33398 2.46007 1.70708 2.83317 2.16732 2.83317Z",
    fill: "#C3C4C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 2.83317C8.46089 2.83317 8.83398 2.46007 8.83398 1.99984C8.83398 1.5396 8.46089 1.1665 8.00065 1.1665C7.54041 1.1665 7.16732 1.5396 7.16732 1.99984C7.16732 2.46007 7.54041 2.83317 8.00065 2.83317Z",
    stroke: "#C3C4C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 2.83317C14.2942 2.83317 14.6673 2.46007 14.6673 1.99984C14.6673 1.5396 14.2942 1.1665 13.834 1.1665C13.3737 1.1665 13.0007 1.5396 13.0007 1.99984C13.0007 2.46007 13.3737 2.83317 13.834 2.83317Z",
    stroke: "#C3C4C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16732 2.83317C2.62755 2.83317 3.00065 2.46007 3.00065 1.99984C3.00065 1.5396 2.62755 1.1665 2.16732 1.1665C1.70708 1.1665 1.33398 1.5396 1.33398 1.99984C1.33398 2.46007 1.70708 2.83317 2.16732 2.83317Z",
    stroke: "#C3C4C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.f6b44d6b4e94d48a6aa3480451451030.svg";
export { ForwardRef as ReactComponent };